import TasksList from '@/common/containers/TasksList/TasksList';

export default TasksList;
